import { useApiMutation } from '@shared/api-utils';
import type { UseMutationOptions } from '@tanstack/react-query';

type UseVerificationApiMutationOptions<TData, TVariables> = {
  mutationOptions?: Omit<UseMutationOptions<TData | null, Error, TVariables>, 'mutationFn'>;
};

function useVerificationApiMutation<TData = unknown, TVariables = unknown>(path: string, options?: UseVerificationApiMutationOptions<TData, TVariables>) {
  const { mutationOptions } = options ?? {};

  return useApiMutation<TData, TVariables>(path, 'POST', {
    mutationOptions,
    requestOptions: { credentials: true },
  });
}

export { useVerificationApiMutation };
